export enum ActivityLogType {
  NOTE = 'NOTE',
  SMS = 'SMS',
  CALL = 'CALL',
  EMAIL = 'EMAIL',
  APPLICANT = 'APPLICANT',
  DOCUMENT = 'DOCUMENT',
  TASK = 'TASK',
  APPLICATION = 'APPLICATION',
  ADVERSE_ACTION = 'ADVERSE_ACTION',
}

export enum SMSDirection {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
}

export enum ActivityLogActorType {
  MANUAL = 'MANUAL',
  AUTOMATED_RULE = 'AUTOMATED_RULE',
  BULK_ACTION = 'BULK_ACTION',
  SYSTEM = 'SYSTEM',
}

export enum CallDirection {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
}

export enum CallStatus {
  INITIATED = 'INITIATED',
  RINGING = 'RINGING',
  IN_PROGRESS = 'IN_PROGRESS',
  NO_ANSWER = 'NO_ANSWER',
  COMPLETED = 'COMPLETED',
  LEFT_VOICEMAIL = 'LEFT_VOICEMAIL',
  LEAVING_VOICEMAIL = 'LEAVING_VOICEMAIL',
  BUSY = 'BUSY',
  FAILED = 'FAILED',
}

export enum CallType {
  BLANDAI = 'BLANDAI',
  TWILIO = 'TWILIO',
}
